// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"286":"a14e5513","655":"8323874d"}[chunkId] + ".chunk.css";
};